<template>
  <div class="login">
    <base-dialog
      :show="!!error"
      title="An error occurred"
      @close="handleError"
    >
      <p>{{ error }}</p>
    </base-dialog>
    <base-content>
      <base-card theme="grey">
        <div class="heading">
          <img
            width="100"
            src="data:image/svg+xml;base64,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"
            alt=""
          />
        </div>
        <form @submit.prevent="submitForm">
          <div class="form-control">
            <label for="email">Email</label>
            <input type="email" name="" id="email" v-model.trim="email" />
          </div>
          <div class="form-control">
            <label for="password">Password</label>
            <input
              type="password"
              name=""
              id="password"
              v-model.trim="password"
              autocomplete="on"
            />
          </div>
          <p v-if="!formIsValid">
            Please enter a valid email and password.
          </p>
          <div class="footer">
            <base-button theme="flat">Login</base-button>
          </div>
        </form>
      </base-card>
    </base-content>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      formIsValid: true,
      isLoading: false,
      error: null
    };
  },
  methods: {
    async submitForm() {
      this.formIsValid = true;
      if (
        this.email === "" ||
        !this.email.includes("@") ||
        this.password.length < 6
      ) {
        this.formIsValid = false;
        return;
      }

      this.isLoading = true;

      const actionPayload = {
        email: this.email,
        password: this.password,
      };

      try {
        await this.$store.dispatch("login", actionPayload);
        // const redirectUrl = '/' + (this.$route.query.redirect || '/');
        const redirectUrl = "/";
        this.$router.replace(redirectUrl);
      } catch (err) {
        this.error = err.message || "Failed to authenticate, try later.";
      }

      this.isLoading = false;
    },
    handleError() {
      this.error = null;
    },
  },
  beforeCreate: function() {
    document.body.className = "bg-grey";
  },
};
</script>

<style scoped>
.heading {
  text-align: center;
  margin: 1rem 0;
}

.footer {
  text-align: center;
  margin-top: 1.5rem;
}

form {
  margin: 0;
  padding: 0;
}

.form-control {
  margin: 0.5rem 0;
}

label {
  margin-bottom: 0.5rem;
  display: block;
  font-size: 14px;
  font-weight: bold;
  line-height: 28px;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  border: 2px solid #fff;
  border-radius: 4px;
  background-color: transparent;
  padding: 0.15rem 0.5rem;
  font-size: 12px;
  line-height: 24px;
}

input:focus,
textarea:focus {
  border-color: #fe5000;
  background-color: #ffa880;
  outline: none;
}
</style>
